import close from './icons/close.png';
import redDot from './icons/red_dot.png';
import logoTW from './icons/logo_tw.png';

export const iconSelector = {
  redDot,
  logoTW,
  close,
};
